import { BehaviorSubject } from 'rxjs';
import { addError, clearError } from './Error';
import {
  getTFUSettings,
  getAdminTFUSettings,
  postTFUSetting,
  putTFUSetting,
  deleteTFUSetting
} from '../Api/TFUSettings/TFUSettingsApi';
import { User } from './User';
import { TicketFollowUpEscalation } from './TFU';

export interface TFUSetting {
  id: string;
  dueOffset: number;
  escalation: TicketFollowUpEscalation;
  ownerId?: string | null;
  owner?: User | null;
  createdAt: Date;
  updatedAt: Date;
}

const tfuSettingSubject = new BehaviorSubject<TFUSetting[]>([]);
const tfuSettingLoadingSubject = new BehaviorSubject<boolean>(false);

export const getTFUSettingsSubject = (): BehaviorSubject<TFUSetting[]> => tfuSettingSubject;
export const getTFUSettingLoadingSubject = (): BehaviorSubject<boolean> => tfuSettingLoadingSubject;

export const fetchTFUSettings = async (isAdmin = false) => {
  tfuSettingLoadingSubject.next(true);

  const { data, error } = await (isAdmin ? getAdminTFUSettings() : getTFUSettings());

  if (data) {
    clearError('tfu-settings');
    tfuSettingSubject.next(data);
  }
  if (error) addError('tfu-settings', error.message);

  tfuSettingLoadingSubject.next(false);
};

export const createTFUSetting = async (object: TFUSetting) => {
  const { data, error } = await postTFUSetting(object);

  if (data) {
    clearError('tfu-settings');
    const currentData = [...getTFUSettingsSubject().getValue()];
    currentData.push(data);
    tfuSettingSubject.next(currentData);
  }
  if (error) addError('tfu-settings', error.message);
};

export const updateTFUSetting = async (object: TFUSetting) => {
  const { data, error } = await putTFUSetting(object);

  if (data) {
    clearError('tfu-settings');
    const currentData = [...getTFUSettingsSubject().getValue()];
    const dataIndex = currentData.findIndex((item) => item.id === data.id);
    if (dataIndex !== -1) {
      currentData[dataIndex] = data;
    } else {
      currentData.push(data);
    }
    tfuSettingSubject.next(currentData);
  }
  if (error) addError('tfu-settings', error.message);
};

export const removeTFUSetting = async (id: string) => {
  const { error } = await deleteTFUSetting(id);
  clearError('tfu-settings');
  if (error) {
    addError('tfu-settings', error.message);
  } else {
    const currentData = [...getTFUSettingsSubject().getValue()];
    const dataIndex = currentData.findIndex((item) => item.id === id);
    if (dataIndex !== -1) {
      currentData.splice(dataIndex, 1);
    }
    tfuSettingSubject.next(currentData);
  }
};
